import { reportInstallOnce } from "./appStats";
import { isStandalone } from "../hooks/useInstallPrompt";

const PLATFORM_SUFFIXES = [".ishukart.org", ".emergentagent.com", ".emergent.host"];
const PLATFORM_HOSTS = new Set(["ishukart.org", "www.ishukart.org", "localhost", "127.0.0.1"]);
export const isPlatformHost = (h) => !h || PLATFORM_HOSTS.has(h) || PLATFORM_SUFFIXES.some((s) => h.endsWith(s));

// Icon/manifest tags live in index.html (so phones and Google see them before JS runs).
// Customer custom domains must not install as "Ishukart" or show its icon.
const stripPlatformTags = () => {
  document.querySelectorAll('link[rel="manifest"], link[rel="apple-touch-icon"], link[rel="icon"], meta[name^="apple-mobile-web-app"], meta[name="mobile-web-app-capable"]')
    .forEach((el) => el.remove());
  const blank = document.createElement("link");
  blank.rel = "icon";
  blank.href = "data:,";
  document.head.appendChild(blank);
};

export const setupInstallableApp = () => {
  if (!isPlatformHost(window.location.hostname)) return stripPlatformTags();
  if (/[?&]source=(app|android|ios)\b/.test(window.location.search)) sessionStorage.setItem("ishukart_in_app", "1");
  if (isStandalone()) reportInstallOnce();
  window.addEventListener("beforeinstallprompt", (e) => {
    window.__installPrompt = e;
    window.dispatchEvent(new Event("installprompt-ready"));
  });
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
  }
};
